(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grandedu-heading-word-fit"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('#MainContent, .pagefly-container');
    if (!root) return;

    const headingSelector = 'h1, h2, h3, h4, h5, h6';
    const pattern = /\bBildungs[\u00ad\u200b]*gutschein\b[.,:;!?]?/gi;
    const records = new Map();
    const pending = new Set();
    let frame = 0;

    const fit = (heading, record) => {
      if (!heading.isConnected) {
        resizeObserver.unobserve(heading);
        records.delete(heading);
        return;
      }

      record.adjustments.forEach(({ element, value, priority }) => {
        if (value) element.style.setProperty('font-size', value, priority);
        else element.style.removeProperty('font-size');
      });
      record.adjustments = [];

      const words = [...heading.querySelectorAll('.ge-bgs-word')];
      if (!words.length || !heading.getClientRects().length) return;

      let width = Infinity;
      for (let element = heading; element; element = element.parentElement) {
        const style = getComputedStyle(element);
        const available = element.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        if (available > 0) width = Math.min(width, available);
        if (element === root) break;
      }
      if (!Number.isFinite(width) || width <= 2) return;

      const targets = [heading, ...heading.querySelectorAll('*')]
        .filter(element => !element.closest('svg, script, style') && !element.classList.contains('ge-bgs-word'))
        .map(element => ({
          element,
          size: parseFloat(getComputedStyle(element).fontSize),
          value: element.style.getPropertyValue('font-size'),
          priority: element.style.getPropertyPriority('font-size')
        }));
      let scale = 1;
      for (let attempt = 0; attempt < 4; attempt += 1) {
        const widest = Math.max(...words.map(word => word.getBoundingClientRect().width));
        if (widest <= width - 1) break;
        scale *= (width - 2) / widest;
        targets.forEach(({ element, size }) => {
          const fontSize = Math.max(1, Math.floor(size * scale * 100) / 100);
          element.style.setProperty('font-size', fontSize + 'px', 'important');
        });
        record.adjustments = targets;
      }
    };

    const flush = () => {
      frame = 0;
      const batch = [...pending];
      pending.clear();
      batch.forEach(heading => {
        const record = records.get(heading);
        if (record) fit(heading, record);
      });
    };

    const schedule = heading => {
      pending.add(heading);
      if (!frame) frame = requestAnimationFrame(flush);
    };

    const scheduleAll = () => records.forEach((record, heading) => schedule(heading));

    const resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const record = records.get(entry.target);
        if (!record || Math.abs(entry.contentRect.width - record.width) < 0.5) return;
        record.width = entry.contentRect.width;
        schedule(entry.target);
      });
    });

    const prepare = heading => {
      if (!root.contains(heading)) return;
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (node.parentElement.closest('.ge-bgs-word, script, style, svg, code')) return NodeFilter.FILTER_REJECT;
          pattern.lastIndex = 0;
          return pattern.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        let offset = 0;
        pattern.lastIndex = 0;
        for (const match of node.nodeValue.matchAll(pattern)) {
          fragment.append(document.createTextNode(node.nodeValue.slice(offset, match.index)));
          const word = document.createElement('span');
          word.className = 'ge-bgs-word';
          word.textContent = match[0].replace(/[\u00ad\u200b]/g, '');
          fragment.append(word);
          offset = match.index + match[0].length;
        }
        fragment.append(document.createTextNode(node.nodeValue.slice(offset)));
        node.replaceWith(fragment);
      });

      if (!heading.querySelector('.ge-bgs-word')) return;
      if (!records.has(heading)) {
        records.set(heading, {
          width: -1,
          adjustments: []
        });
        resizeObserver.observe(heading);
      }
      schedule(heading);
    };

    const scan = node => {
      const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
      if (!element || element.closest('.ge-bgs-word')) return;
      const heading = element.closest(headingSelector);
      if (heading) prepare(heading);
      element.querySelectorAll(headingSelector).forEach(prepare);
    };

    scan(root);

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'characterData') scan(mutation.target);
        else mutation.addedNodes.forEach(scan);
      });
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', scheduleAll, { passive: true });
    document.addEventListener('shopify:section:load', event => scan(event.target));
    if (document.fonts) {
      document.fonts.ready.then(scheduleAll);
      document.fonts.addEventListener('loadingdone', scheduleAll);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grandedu-mba-ihk-pathways"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ge-mba-pathway-explorer')) {
  customElements.define('ge-mba-pathway-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[data-pathway-panel]'));
      const select = this.querySelector('select');
      const navigation = this.querySelector('.ge-mba-pathways__navigation');
      if (!tabs.length || tabs.length !== panels.length || !select || !navigation) return;
      const activate = (id, moveFocus = false) => {
        tabs.forEach(tab => {
          const active = tab.dataset.pathway === id;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.pathwayPanel !== id; });
        select.value = id;
      };
      panels.forEach((panel, index) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs[index].id);
        panel.tabIndex = 0;
      });
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.pathway));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[next].dataset.pathway, true);
        });
      });
      select.addEventListener('change', () => activate(select.value));
      activate(tabs[0].dataset.pathway);
      navigation.hidden = false;
      this.dataset.enhanced = 'true';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
